import React, { useState, useContext } from 'react';
import { Form, } from 'react-bootstrap';
import TitleBar from '../../comonents/TitleBar';
import CustomerDemands from '../../comonents/CustomerDemands';
import ArrowDownRight from '../../comonents/Icons/Arrow-down-right'
import ArrowUpRight from '../../comonents/Icons/Arrow-up-right'
import { Context } from '../../context/Context'
import axios from '../../axios'
import ErrorModal from '../../comonents/ErrorModal';
import { EXPRESS_SERVER_URL, MIN_MINER_COUNT } from "../../config";
import { useNavigate } from 'react-router-dom'
import './index.css'
import PopUpModal from '../../comonents/PopUpModal';

export default function DashboradVerfy2() {

    const navigate = useNavigate();

    const { setGame2CanLogout, } = useContext(Context);

    const [cases, setCases] = React.useState(1);

    const [h12, setH12] = React.useState('');
    const [h2, setH2] = React.useState('');
    const [n12, setN12] = React.useState('');
    const [n2, setN2] = React.useState('');

    const [showMSG, setShowMSG] = React.useState(false);
    const [msg, setMSG] = React.useState("");
    const [title, setTitle] = React.useState("");
    const [btnText, setBtnText] = React.useState("")

    const [clickable, setClickable] = React.useState(false)

    React.useEffect(() => {
        if (h12.length > 0 && h2.length > 0 && n12.length > 0 && n2.length > 0) {
            setClickable(true)
        } else {
            setClickable(false)
        }
    }, [h12, h2, n12, n2])

    const diffClick = () => {
        if (cases === 1) {
            setTitle("Congratulation!")
            setMSG("Your are right. In case 1, the order2's data has changed.");
            setBtnText('Next')
            setShowMSG(true)
        } else {
            setTitle("Ohhh...")
            setMSG("Your are wrong. In case 2, the order2's data has not changed.");
            setBtnText('Complete!')
            setShowMSG(true)
        }
    }

    const sameClick = () => {
        if (cases === 1) {
            setTitle("Ohhh...")
            setMSG("Your are wrong. In case 1, the order2's data has changed.");
            setBtnText('Next')
            setShowMSG(true)
        } else {
            setTitle("Congratulation!")
            setMSG("Your are right. In case 2, the order2's data has not changed.");
            setBtnText('Complete!')
            setShowMSG(true)
        }
    }

    const nextClick = () => {
        if (cases === 1) {
            setH12("");
            setH2("");
            setN12("");
            setN2("");
            setShowMSG(false)
            setCases(2)
        } else {
            setGame2CanLogout(true)
            navigate('/point')
        }
    }

    return (
        <main>
            <TitleBar backLastPage="" lastPageName="point" />

            <div className='DashBoardVerfy2'>
                RULE : Given the data of order 2, and the value of Hash1 and Hash34 required to calculate the Root Value, calculate the Root Hash, and compare the calculated Root Hash with the original value. If there is a difference, it means that the order 2 data has changed.
            </div>
            <div className='row HashCase'>
                <div className='col-4 text-end hCaseTitle'>
                    CASE {cases}
                </div>
                <div className='col-8 hCaseBoard'>
                    Order : 2<br />
                    <div className="d-flex justify-content-between">
                        <div>Product ID       :</div>
                        <div>C1041</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div>Customer ID      :</div>
                        <div>KL02</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div>Product Quantity :</div><div>{cases === 1 ? '100' : '132'}</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div>Product Name     :</div>
                        <div>Penfolds</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div>Delivery Date    :</div><div>13OCT2020</div>

                    </div>
                </div>
            </div>
            <div className='row hashGroup'>
                <div className='row'>
                    <div className='col-4 hashpink'>Hash 1<br />
                        Pre. Hash:21<br />
                        Hash:1743<br />
                        Nonce: 2<br />
                    </div>
                    <div className='col-3'>
                        <br />
                        <br />
                        <br />
                        {ArrowDownRight()}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'></div>
                    <div className='col-4 hashyellow '>Hash 12<br />
                        Hash: <input className='hashinputbtn' value={h12} onChange={e => setH12(e.target.value)} />  <br />
                        Nonce: <input className='hashinputbtn' value={n12} onChange={e => setN12(e.target.value)} />   <br />
                    </div>
                    <div className='col-4'>
                        <br />
                        <br />
                        <br />
                        {ArrowDownRight()}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-4 hashaquamarine'>Hash 2<br />
                        Pre. Hash:21<br />
                        Hash: <input className='hashinputbtn' value={h2} onChange={e => setH2(e.target.value)} /><br />
                        Nonce: <input className='hashinputbtn' value={n2} onChange={e => setN2(e.target.value)} /><br />
                    </div>
                    <div className='col-2'>
                        {ArrowUpRight()}
                    </div>
                    <div className='col-2'></div>
                    <div className='col-4 hashyellow'>
                        Hash 1234<br />
                        Hash: 231<br />
                        Nonce: 31<br />

                    </div>
                </div>
                <div className='row'>
                    <div className='col-4'></div>

                    <div className='col-4 hashpink'>Hash 34<br />
                        Hash: 273<br />
                        Nonce: 3<br />
                    </div>
                    <div className='col-3'>
                        {ArrowUpRight()}
                    </div>
                    <div className='col-2'></div>
                </div>

            </div>
            <div>
                The order 2 data is ____________:
            </div>
            <div className='row buttonsGroup'>
                <div className='row' >
                    <div className='col-6  '>
                        <button disabled={!clickable} className='btn btn-danger btn-different' onClick={diffClick}>Different</button>
                    </div>
                    <div className='col-6  '>
                        <button disabled={!clickable} className='btn btn-primary btn-same' onClick={sameClick}>Same</button>
                    </div>
                </div>
                <div className='row d-flex justify-content-center'>
                    <button className='btn btn-light btn-back' onClick={() => navigate(-1)}>Back</button>
                </div>
            </div>
            <PopUpModal setShowMSG={setShowMSG} showMSG={showMSG} MSGContext={msg} MSGTitle={title} MSGBtn={btnText} onClick={nextClick} Link={""} />
        </main>
    )
}